import { logger } from "../logger";
import axiosInstance, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";

export const axios = axiosInstance

export function setup() {
    // axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
    //     alert(config.url)
    //     if (config.url) {
    //         logger.info(config.url)
    //     }
    //     if (config.data) {
    //         logger.info(config.data)
    //         logger.info(JSON.stringify(config.data))
    //     }
    //     return config
    // }, (error: any) => {
    //     console.info(error)
    // })

    // axiosInstance.interceptors.response.use((response: AxiosResponse) => {
    //     alert('2')
    //     if (response && response.data) {
    //         logger.info(response.data)
    //         if (response.data.data && !(response.data.data instanceof Array) && Object.entries(response.data.data).length === 0) {
    //             logger.info("empty data error")
    //             throw "empty data error"
    //         }
    //     } else {
    //         logger.info("null data error")
    //         throw "null data error"
    //     }
    //     return response
    // }, (error: AxiosError) => {
    //     alert('3')
    //     logger.info(error)
    //     if (error) {
    //         if (error.response) {
    //             let errorJSON = JSON.parse(JSON.stringify(error.response.request.response))
    //             logger.info(errorJSON)
    //             throw errorJSON
    //         } else {
    //             let errorJSON = JSON.parse(JSON.stringify(error));
    //             logger.info(errorJSON)
    
    //             throw errorJSON.message
    //         }
    //     }
    //     return error
    // })
}

export class ServiceError {
    code: string
    description: string

    constructor(code: string, description: string) {
        this.code = code
        this.description = description
    }

    toString() {
        return this.description
    }
}

export function tryParseServiceError(errorInfo: string): ServiceError | undefined {
    try {
        const errorResponse: { errors?: any[] } = JSON.parse(errorInfo)
        if (errorResponse.errors) {
            let serviceError: any = null
            errorResponse.errors.forEach(error => {
                if (!serviceError) {
                    serviceError = new ServiceError(error.code, error.detail)
                }
            });
            return serviceError
        }
    }
    catch (parseError) {
        return undefined
    }
}


export function migratedTryParseServiceError(errorInfo: any) {
    try {
        let serviceError: any = null
        if(errorInfo["response"] != undefined) {
            // return errorInfo.response.data.errors[0].detail;
            if(errorInfo.response.data["errors"] != undefined) {
                errorInfo.response.data.errors.forEach((error: any) => {
                    if (!serviceError) {
                        serviceError = new ServiceError(error.code, error.detail);
                    }
                });
            } else {
                if(errorInfo.response.status == 401) {
                    window.localStorage.clear();
                    window.location.href = '/login';
                    serviceError = new ServiceError(errorInfo.response.data.statusCode, errorInfo.response.data.error);
                } else {
                    serviceError = new ServiceError(errorInfo.response.data.statusCode, errorInfo.response.data.error);
                }
                // If the above code is worked we will remove below commented code
                // else if(errorInfo.response.status == 500) {
                //     serviceError = new ServiceError(errorInfo.response.data.statusCode, errorInfo.response.data.error);
                // }
            }
           
            return serviceError
        } else {
            serviceError = new ServiceError(errorInfo.code, errorInfo.message);
            return serviceError
        }
    }
    catch (parseError) {
        return parseError
    }
}

export class Result<T> {
    total: number
    fetched: T[]

    constructor(total: number, fetched: T[]) {
        this.total = total
        this.fetched = fetched
    }
}